import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CallbackComponent implements OnInit {
    profile = null;

    constructor(private userService: UserService) {}

    ngOnInit() {
        this.userService.user$.pipe(takeWhile(() => this.profile === null)).subscribe((p) => {
            this.profile = p;
        });
    }
}
